import Axios from '@/assets/js/AxiosPlugin'
// 已发送列表列表
export const getSendCouponList = params => {
  return Axios.post('/api/Admin/Member/getSendCouponList', params)
}
// 添加充值项
export const addRechargeCouponItem = params => { return Axios.post('/api/Admin/Member/addSendCouponItem', params) }



// WEBPACK FOOTER //
// ./src/views/webpc/MemberManagement/SendCouponList/apis/index.js